module.exports = __webpack_public_path__ + "img/65.bcd1a50f.jpg";